<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="substanceUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="substances"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-substance
      :substance="{ abbreviation: '', name: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-substance
      :key="substanceUpdateKey"
      :substance="selectedSubstance"
      :visible="dialogType === 'update'"
      :id="selectedSubstance.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-substance
      :visible="dialogType === 'delete'"
      :substance="selectedSubstance"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-substance>
  </div>
</template>

<script>
import CreateSubstance from "./CreateSubstance";
import UpdateSubstance from "./UpdateSubstance";
import DeleteSubstance from "./DeleteSubstance";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateSubstance,
    UpdateSubstance,
    DeleteSubstance,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "name" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      substanceUpdateKey: null,
      substanceList: [],
      isLoading: false,
      dialogType: "",
      selectedSubstance: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "substances"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchSubstances", "createSubstance", "updateSubstance"]),
    editSubstance(substance) {
      this.selectedSubstance = { ...substance };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },
    openModal(type, substance) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedSubstance = { ...substance };
      }
    },
    openDeleteModal(type, substance) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedSubstance = { ...substance };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedSubstance = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedSubstance = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createSubstance(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateSubstance(item);
      this.substanceUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchSubstances()
        .then(() => {
          this.$store.commit("setSubstanceTypeResults", response.data);
          this.substances = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  handleSearch(query) {
    this.getSearchquery = query;
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
